import templateUrl from "./search-bar.html";

export const searchBarComponent = {
  templateUrl,

  bindings: {
    onChange: "&",
    onKeydown: "&",
    placeholder: "@",
  },
  controller: class SearchBarComponent {
    constructor(Constants) {
      "ngInject";
      this.Constants = Constants;
    }
    $onInit() {
      this.searchKeyword = "";
      this.placeholder = this.placeholder ? this.placeholder : "Search Keyword";
    }
    onSearch(e) {
      this.onChange({value: e.target.value});
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/search-bar/search-bar.component.js